export const payoutDailySelector = (state) =>
  state.payoutDailyReducer?.records || [];

export const payoutDailyLoadingSelector = (state) =>
  state.payoutDailyReducer?.loading || false;
